import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿En qué formato recibo el material?',
    a: '100% digital: PDF descargables listos para usar.'
  }, {
    q: '¿Puedo imprimir el material?',
    a: 'Sí, sin restricciones.'
  }, {
    q: '¿Para qué año sirve?',
    a: 'Adaptable a 4° y 5° año de secundaria.'
  }, {
    q: '¿Necesito materiales especiales?',
    a: 'No. Está diseñado para recursos accesibles.'
  }, {
    q: '¿Cuánto tarda en llegar?',
    a: 'Acceso inmediato tras la compra.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white py-6 px-4" data-id="element-46">
      <div className="max-w-3xl mx-auto" data-id="element-47">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-6" data-id="element-48">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-49">
          {faqs.map((faq, i) => <div key={i} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-50">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-51">
                <span className="font-bold text-gray-900" data-id="element-52">{faq.q}</span>
                {openIndex === i ? <ChevronUp className="w-5 h-5 text-gray-500" data-id="element-53" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-54" />}
              </button>
              {openIndex === i && <div className="p-4 bg-white border-t border-gray-100 text-gray-700" data-id="element-55">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}